<main class="container">
  <h1 class="title text-center">Instituições ofertantes</h1>
  <app-barra-busca-instituicoes-olinda [ufs]="ufs" [componenteRef]="componenteRef"
    (inputEventBuscaOlinda)="buscaInformacoesInstituicaoOlinda($event)"
    (inputEventBuscaCache)="buscaInformacoesInstituicaoCache($event)"
    (listaInstituicaoCache)="listaTodasInstituicaoCache($event)">
  </app-barra-busca-instituicoes-olinda>

  <section>
    <p *ngIf="totalResultados" class="text-center results mensagem">
      Total de resultados encontrados {{ totalResultados }}
    </p>
    <p *ngIf="msgSemInstituicao" class="text-center results mensagem">
      Desculpe, não encontramos nenhum resultado compatível com sua busca.
    </p>

    <ul>
      <li class="card list-style bg-color-white contrast-border" *ngFor="let instituicao of pagedItems">
        <app-card-instituicao [titulo]="[instituicao.nome]" [nome]="instituicao.nome" [tipo]="instituicao.tipo"
          [endereco]="instituicao.endereco" [telefone]="instituicao.telefone" [email]="instituicao.email"
          [homePage]="instituicao.site">
        </app-card-instituicao>
      </li>
      <hr class="hr-line bg-color-dark-grey" />
    </ul>

    <!-- pager -->
    <ul *ngIf="pager && pager.pages && pager.pages.length" class="paginacao">
      <li [class.disabled]="pager.currentPage === 1">
        <a (click)="setPage(1)" class="arrows" title="Ir para primeira pagina">&laquo;</a>
      </li>
      <li [class.disabled]="pager.currentPage === 1">
        <a (click)="setPage(pager.currentPage - 1)" class="arrows" title="Ir para pagina anterior">&lsaquo;</a>
      </li>
      <li *ngFor="let page of pager.pages" [ngClass]="{ active: pager.currentPage === page }" class="pagination-item">
        <a (click)="setPage(page)">{{ page }}</a>
      </li>
      <li [class.disabled]="pager.currentPage === pager.totalPages">
        <a (click)="setPage(pager.currentPage + 1)" class="arrows" title="Ir para a proxima página">&rsaquo;</a>
      </li>
      <li [class.disabled]="pager.currentPage === pager.totalPages">
        <a (click)="setPage(pager.totalPages)" class="arrows" title="Ir para a última página">&raquo;</a>
      </li>
    </ul>
  </section>
  <span *ngIf="totalResultados || (totalResultados && realizouBusca)">
    <div class="p-3" align="center" role="none">
      <button type="button" class="btn btn-md btn-grey rounded-pill cursor-pointer" (click)="exportToCsv()">
        <i class="fas fa-download" aria-hidden="true"></i>
        Gerar .CSV
      </button>
    </div>
  </span>
</main>